export const inputIds = {
    signUpCompany: 'signUpCompany',
    signUpEmail: 'signUpEmail',
    signUpFirstName: 'signUpFirstName',
    signUpLastName: 'signUpLastName',
    signUpPassword: 'signUpPassword',
};
